<script setup lang="ts">
   withDefaults(
      defineProps<{
         size?: string;
         color?: string;
      }>(),
      {
         size: 'w-10 h-10',
         color: 'primary-500',
      }
   );
</script>

<template>
   <span class="loader mx-auto" :class="`${size} border-${color}`"></span>
</template>
<style>
   .loader {
      border-style: solid;
      border-width: 0.25rem;
      border-bottom-color: transparent;
      border-radius: 50%;
      display: block;
      box-sizing: border-box;
      animation: rotation 1s linear infinite;
   }
   @keyframes rotation {
      0% {
         transform: rotate(0deg);
      }
      100% {
         transform: rotate(360deg);
      }
   }
</style>
